import { useQuery } from '@apollo/client';
import { useGetHelpdeskTicketRules } from 'ui-addon-conversations-settings/tickets/queries/getHelpdeskTicketRules';
import { FetchTicket } from 'conversations-thread-data/tickets/public/mutations';
export const useSavedPipelineInformation = ticketId => {
  var _ticketData$crmObject, _pipelineInfo$pipelin, _pipelineInfo$current;
  const {
    data: ticketData,
    loading: ticketLoading
  } = useQuery(FetchTicket, {
    variables: {
      ticketId
    },
    skip: !ticketId
  });
  const pipelineInfo = ticketData ? ticketData === null || ticketData === void 0 || (_ticketData$crmObject = ticketData.crmObject) === null || _ticketData$crmObject === void 0 ? void 0 : _ticketData$crmObject.pipelineInfo : null;
  const savedPipelineProperty = pipelineInfo === null || pipelineInfo === void 0 || (_pipelineInfo$pipelin = pipelineInfo.pipeline) === null || _pipelineInfo$pipelin === void 0 ? void 0 : _pipelineInfo$pipelin.pipelineId;
  const savedStatusProperty = pipelineInfo === null || pipelineInfo === void 0 || (_pipelineInfo$current = pipelineInfo.currentStage) === null || _pipelineInfo$current === void 0 ? void 0 : _pipelineInfo$current.stageId;
  return {
    savedPipelineProperty,
    savedStatusProperty,
    ticketLoading
  };
};
export const useDefaultPipelineInformation = () => {
  const {
    data: defaultData,
    loading: defaultLoading
  } = useGetHelpdeskTicketRules();
  const rules = defaultData ? defaultData.helpdeskTicketRules.properties : null;
  const defaultPipelineProperty = rules === null || rules === void 0 ? void 0 : rules.hs_pipeline.value;
  const defaultStatusProperty = rules === null || rules === void 0 ? void 0 : rules.hs_pipeline_stage.value;
  return {
    defaultPipelineProperty,
    defaultStatusProperty,
    defaultLoading
  };
};